import type { NotifyPort } from '@/features/messages/domain/notify'
import type { TimeOffPort, TimeOffBalance } from '../domain/timeoff'

const listBalances = async (
	port: TimeOffPort,
	memberId: string | undefined,
	notify: NotifyPort,
	memberIds?: string[],
): Promise<TimeOffBalance[]> => {
	try {
		return await port.listBalances(memberId, memberIds)
	} catch {
		notify.error('hr.balancesLoadFailed')
		return []
	}
}

export { listBalances }
